import ClientInstance from '../ClientInstance';
import { localeFlag } from '../ApiHelpers';

export interface IOrganizationsOwners {
  putOwner?: any;
  getOrganization?: any;
  putOrganization?: any;
  putOrganizationLogo?: any;
  putUser?: any;
  postAdmins?: any;
  putAdmins?: any;
  updateAdmins?: any;
  deleteAdmin?: any;
  putOrgImage?: any;
  postGroup?: any;
  postGroupWhiteTeacher?: any;
  putGroupWhiteTeacher?: any;
  getUser?: any;
  putGroup?: any;
}

export interface IOrganizationsAdmins {
  // ..
}

export interface IOrganizationsTeachers {
  getOrganization?: any;
  getTeacher?: any;
  getUser?: any;
  postGroup?: any;
  postGroupWhiteTeacher?: any;
  putGroupWhiteTeacher?: any;
  putUser?: any;
  putGroup?: any;
  deleteTeacher?: any;
  putTeacher?: any;
  postTeacher?: any;
  putOrgImage?: any;
}


export interface IOrganizationsDirectors {
  getOrganization?: any;
  getTeacher?: any;
  getUser?: any;
  postGroup?: any;
  postGroupWhiteTeacher?: any;
  putGroupWhiteTeacher?: any;
  putUser?: any;
  putGroup?: any;
  deleteTeacher?: any;
  putTeacher?: any;
  postTeacher?: any;
  putOrgImage?: any;
}

export interface ICentersShared {
  deleteGroup?: any;
  putOrgImage?: any;
  putOrganizationLogo?: any;
}
interface IOrganizations {
  owners: IOrganizationsOwners;
  admins: IOrganizationsAdmins;
  director: IOrganizationsDirectors;
  teachers: IOrganizationsTeachers;
  shared: ICentersShared;
}

const organizations: IOrganizations = {
  owners: {
    putOwner: (body: any) => ClientInstance.put('/organizations/owners/owner', body),
    getOrganization: () => ClientInstance.get('/organizations/owners/organization'),
    putOrganization: (body: any) => ClientInstance.put('/organizations/owners/organization', body),
    putOrganizationLogo: (body: any) => ClientInstance.put('/organizations/shared/organization/add_logo', body),
    postAdmins: (body: any) => ClientInstance.post('/organizations/owners/admins', body),
    putAdmins: (body: any, id: number) => ClientInstance.put(`/organizations/shared/admins/${id}`, body),
    updateAdmins: ({ body, centerId, directorId }: any) =>ClientInstance.put(`/organizations/shared/centers/${centerId}/directors/${directorId}`, body),
    deleteAdmin: (id: number) => ClientInstance.delete(`/organizations/owners/admins/${id}`),
    postGroup: (centerId: number, body: any) => ClientInstance.post(`/organizations/shared/centers/${centerId}/groups?${localeFlag()}`, body),
    postGroupWhiteTeacher: (body: any) => ClientInstance.post(`/centers/shared/groups`, body),
    putGroupWhiteTeacher: (groupId: number, body: any) => ClientInstance.put(`/centers/shared/groups/${groupId}`, body),
    getUser: (params: any = {}) => ClientInstance.get('/users', { params }),
    putUser: (body: any) => ClientInstance.put('/users', body),
    putGroup: (centerId: number, groupId: number, body: any) => ClientInstance.put(`/organizations/shared/centers/${centerId}/groups/${groupId}`, body),
    putOrgImage: (body: any) => ClientInstance.put('/accounts/add_logo', body),
  },
  admins: {
    getOrganization: () => ClientInstance.get('/organizations/admins/organization'),
    putAdmins: (body: any, id: number) => ClientInstance.put(`/organizations/shared/admins/${id}`, body),
    getUser: (params: any = {}) => ClientInstance.get('/users', { params }),
    putUser: (body: any) => ClientInstance.put('/users', body),
    postAdmins: (body: any) => ClientInstance.post('/organizations/owners/admins', body),
    postGroup: (centerId: number, body: any) => ClientInstance.post(`/organizations/shared/centers/${centerId}/groups?${localeFlag()}`, body),
    putGroup: (centerId: number, groupId: number, body: any) => ClientInstance.put(`/organizations/shared/centers/${centerId}/groups/${groupId}`, body),
    putOrgImage: (body: any) => ClientInstance.put('/accounts/add_logo', body),
  },
  director: {
    getOrganization: () => ClientInstance.get('/organizations/shared/organization'),
    getTeacher: () => ClientInstance.get('/centers/teachers/profile'),
    getUser: (params: any = {}) => ClientInstance.get('/users', { params }),
    putUser: (body: any) => ClientInstance.put('/users', body),
    postGroup: (centerId: number, body: any) => ClientInstance.post(`/organizations/shared/centers/${centerId}/groups?${localeFlag()}`, body),
    postGroupWhiteTeacher: (body: any) => ClientInstance.post(`/centers/shared/groups`, body),
    putGroupWhiteTeacher: (groupId: number, body: any) => ClientInstance.put(`/centers/shared/groups/${groupId}`, body),
    putGroup: (centerId: number, groupId: number, body: any) => ClientInstance.put(`/organizations/shared/centers/${centerId}/groups/${groupId}`, body),
    deleteTeacher: (centerId: number, teacherId: number) => ClientInstance.delete(`/organizations/owners/centers/${centerId}/teachers/${teacherId}`),
    putTeacher: (body: any, centerId: number, teacherId: number) => ClientInstance.put(`/organizations/shared/centers/${centerId}/teachers/${teacherId}`, body),
    putOrgImage: (body: any) => ClientInstance.put('/accounts/add_logo', body),
  },
  teachers: {
    getOrganization: () => ClientInstance.get('/organizations/teachers/organization'),
    getTeacher: () => ClientInstance.get('/centers/teachers/profile'),
    getUser: (params: any = {}) => ClientInstance.get('/users', { params }),
    putUser: (body: any) => ClientInstance.put('/users', body),
    postGroup: (centerId: number, body: any) => ClientInstance.post(`/organizations/shared/centers/${centerId}/groups?${localeFlag()}`, body),
    postGroupWhiteTeacher: (body: any) => ClientInstance.post(`/centers/shared/groups`, body),
    putGroupWhiteTeacher: (groupId: number, body: any) => ClientInstance.put(`/centers/shared/groups/${groupId}`, body),
    putGroup: (centerId: number, groupId: number, body: any) => ClientInstance.put(`/organizations/shared/centers/${centerId}/groups/${groupId}`, body),
    deleteTeacher: (centerId: number, teacherId: number) => ClientInstance.delete(`/organizations/owners/centers/${centerId}/teachers/${teacherId}`),
    putTeacher: (body: any, centerId: number, teacherId: number) => ClientInstance.put(`/organizations/shared/centers/${centerId}/teachers/${teacherId}`, body),
    putOrgImage: (body: any) => ClientInstance.put('/accounts/add_logo', body),
  },
  shared: {
    deleteGroup: (centerId: number, groupId: number) => ClientInstance.delete(`/organizations/shared/centers/${centerId}/groups/${groupId}?${localeFlag()}`),
    putOrgImage: (body: any) => ClientInstance.put('/accounts/add_logo', body),
    putOrganizationLogo: (body: any) => ClientInstance.put('/organizations/shared/organization/add_logo', body),

  },
};

const centers = {
  // ..
};

export default {
  organizations,
  centers,
};
